// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryTuningAutomatedExplainDetailQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  explainId: Types.Scalars["ID"]["input"];
}>;

export type QueryTuningAutomatedExplainDetailQuery = {
  __typename?: "GraphqlQuery";
  getQueryExplain?: {
    __typename?: "QueryExplain";
    id: string;
    annotatedJson?: any | null;
    insightsWithRewrite: Array<{
      __typename?: "InsightWithRewrite";
      id: string;
      nodeId: string;
      rewriteType: string;
      originalQuery: string;
      rewriteQuery?: string | null;
    } | null>;
  } | null;
};

export const QueryTuningAutomatedExplainDetailDocument = gql`
  query QueryTuningAutomatedExplainDetail($databaseId: ID!, $explainId: ID!) {
    getQueryExplain(databaseId: $databaseId, explainId: $explainId) {
      id
      annotatedJson
      insightsWithRewrite {
        id
        nodeId
        rewriteType
        originalQuery
        rewriteQuery
      }
    }
  }
`;

/**
 * __useQueryTuningAutomatedExplainDetailQuery__
 *
 * To run a query within a React component, call `useQueryTuningAutomatedExplainDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryTuningAutomatedExplainDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryTuningAutomatedExplainDetailQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      explainId: // value for 'explainId'
 *   },
 * });
 */
export function useQueryTuningAutomatedExplainDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  > &
    (
      | {
          variables: QueryTuningAutomatedExplainDetailQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  >(QueryTuningAutomatedExplainDetailDocument, options);
}
export function useQueryTuningAutomatedExplainDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  >(QueryTuningAutomatedExplainDetailDocument, options);
}
// @ts-ignore
export function useQueryTuningAutomatedExplainDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryTuningAutomatedExplainDetailQuery,
  QueryTuningAutomatedExplainDetailQueryVariables
>;
export function useQueryTuningAutomatedExplainDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTuningAutomatedExplainDetailQuery,
        QueryTuningAutomatedExplainDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryTuningAutomatedExplainDetailQuery | undefined,
  QueryTuningAutomatedExplainDetailQueryVariables
>;
export function useQueryTuningAutomatedExplainDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTuningAutomatedExplainDetailQuery,
        QueryTuningAutomatedExplainDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryTuningAutomatedExplainDetailQuery,
    QueryTuningAutomatedExplainDetailQueryVariables
  >(QueryTuningAutomatedExplainDetailDocument, options);
}
export type QueryTuningAutomatedExplainDetailQueryHookResult = ReturnType<
  typeof useQueryTuningAutomatedExplainDetailQuery
>;
export type QueryTuningAutomatedExplainDetailLazyQueryHookResult = ReturnType<
  typeof useQueryTuningAutomatedExplainDetailLazyQuery
>;
export type QueryTuningAutomatedExplainDetailSuspenseQueryHookResult =
  ReturnType<typeof useQueryTuningAutomatedExplainDetailSuspenseQuery>;
export type QueryTuningAutomatedExplainDetailQueryResult = Apollo.QueryResult<
  QueryTuningAutomatedExplainDetailQuery,
  QueryTuningAutomatedExplainDetailQueryVariables
>;
